<template>
	<c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="字典类型" required tip="请选择字典关联类型">
        <c-select ref="dicSelect" name="dic_type_id" async @search="searchDicType"></c-select>
      </c-form-item>
      <c-form-item label="字典值代码" required tip="同一类型下，字典值代码不允许重复">
          <c-input name="code" maxlength="20"></c-input>
      </c-form-item>
      <c-form-item label="字典值名称" required tip="同一类型下，字典值名称不允许重复">
          <c-input name="name" maxlength="20"></c-input>
      </c-form-item>
      <c-form-item label="字典值颜色">
        <c-color name="color" v-model="color"></c-color>
      </c-form-item>
      <c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
            editState: false,
            color:'#000000',
		}
	},

	methods: {
    /*******搜索字典类型*****************/
    searchDicType(keyword, resolve){
      this.request({
        url:'/dic/type/options',
        data: {
            keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******查询字典值详情*****************/
    getDetail(id){
      this.request({
        url:'/spu/brand/detail',
        data: {
          id: id
        },
        success:data => {
          if (data && data.category_list){
            //已选中的[分类]

          }
        }
      })
    },
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
                this.$refs.form.set(data);
                this.$refs.dicSelect.setValueData([{
                    name: data.dic_type_name,
                    value:data.dic_type_id
                }])
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑字典值' : '添加字典值'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/dic/edit/info':'/dic/add/info',
				rule: {
                    dic_type_id: '请选择字典值关联的类型',
                    code: '请输入字典值代码',
                    name: '请输入字典值名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if(this.editState){
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else{
                        this.$message({
                          message: '添加成功',  // 提示内容,
                          type: 'success'
                        });
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>